import { useState } from "react";
import { Box, Button, Theme, Typography } from "@mui/material";
import AssetAllocationGuidelinesTable from "./tables/assetAllocationGuidelinesTable";
import PortfolioPrudentialNorms from "./portfolioPrudentialNorms";
import { ComplianceProps } from "./portfolioAnalytics/compliance";


export default function AssetAllocationCompliance(props: ComplianceProps): JSX.Element {
    const { clientCode, portfolioId } = props;

    const [activeTab, setActiveTab] = useState<string>("Asset Allocation Guidelines")

    const handleTabChange = (tab: string) => {
        setActiveTab(tab)
    }
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    display: 'flex',
                    gap: '10px',
                    backgroundColor: theme.palette.grey[50],
                    padding: '10px',
                    borderRadius: '8px',
                })}
            >
                {["Asset Allocation Guidelines", "Portfolio Prudential Norms"].map((item) => {
                    return (
                        <Button
                            variant={activeTab === item ? "contained" : "text"}
                            key={item}
                            onClick={() => handleTabChange(item)}
                            sx={(theme: Theme) => ({
                                padding: '0px 15px',
                                background: activeTab === item ? theme.palette.primary[100] : 'transparent',
                                borderRadius: '7px',
                                outline: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                '&:hover': {
                                    background: activeTab ? theme.palette.primary[100] : theme.palette.primary[50],
                                }
                            })}
                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: activeTab === item ? theme.palette.text.primary : theme.palette.text.secondary,
                                    letterSpacing: '0.02px'
                                })}
                            >
                                {item}
                            </Typography>
                        </Button>
                    )
                })}
            </Box>
            <Box sx={{ mt: '25px' }}>
                {activeTab === 'Asset Allocation Guidelines' && <AssetAllocationGuidelinesTable
                    clientCode={clientCode}
                    portfolioId={portfolioId}
                />}
                {activeTab === "Portfolio Prudential Norms" && (
                    <PortfolioPrudentialNorms
                        clientCode={clientCode}
                        portfolioId={portfolioId}
                    />
                )}
            </Box>
        </>
    )
}